import {ChangeDetectionStrategy, Component, input, output} from '@angular/core';
import {Project} from 'src/app/core/model/project';
import {CurrentSkedTask} from 'src/app/core/model/task';
import {OphIconModule} from 'src/app/shared/design/oph-icon/oph-icon.module';
import {PipesModule} from 'src/app/shared/pipes/pipes.module';

@Component({
  selector: 'current-sked-task',
  standalone: true,
  imports: [OphIconModule, PipesModule],
  templateUrl: './current-sked-task.component.html',
  styleUrl: './current-sked-task.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CurrentSkedTaskComponent {
  task = input.required<CurrentSkedTask>();
  project = input.required<Project>();
  expired = input.required<boolean>();

  taskClick = output<CurrentSkedTask>();
}
